import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2756f2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-ai-center" }
const _hoisted_2 = {
  key: 0,
  class: "p-pl-2",
  style: {"padding-right":"1em"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map-marker large-icon" }, null, -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "shopfields" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GvInputText = _resolveComponent("GvInputText")!
  const _component_GVAutocomplete = _resolveComponent("GVAutocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.props.showAvatar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_GvInputText, {
        disabled: _ctx.props.disableFields,
        class: "inputfield",
        "field-name": "Nome insegna *",
        id: "signName",
        errors: _ctx.v$.signName.$silentErrors,
        "is-dirty": _ctx.v$.signName.$dirty,
        modelValue: _ctx.v$.signName.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.signName.$model) = $event))
      }, null, 8 /* PROPS */, ["disabled", "errors", "is-dirty", "modelValue"]),
      _createVNode(_component_GvInputText, {
        disabled: _ctx.props.disableFields,
        class: "inputfield",
        "field-name": "Referente punto vendita (nome e cognome)",
        id: "referrer",
        errors: [],
        modelValue: _ctx.v$.referrer.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.referrer.$model) = $event))
      }, null, 8 /* PROPS */, ["disabled", "modelValue"]),
      _createVNode(_component_GvInputText, {
        disabled: _ctx.props.disableFields,
        class: "inputfield",
        "field-name": "Numero di telefono referente",
        id: "phoneNumber",
        errors: _ctx.v$.phoneNumber.$silentErrors,
        "is-dirty": _ctx.v$.phoneNumber.$dirty,
        modelValue: _ctx.v$.phoneNumber.$model,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.phoneNumber.$model) = $event))
      }, null, 8 /* PROPS */, ["disabled", "errors", "is-dirty", "modelValue"]),
      _createVNode(_component_GVAutocomplete, {
        disabled: _ctx.props.disableFields,
        class: "inputfield",
        "field-name": "Indirizzo punto vendita *",
        modelValue: _ctx.v$.address.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.address.$model) = $event)),
        "is-dirty": _ctx.v$.address.$dirty,
        id: "address",
        errors: _ctx.v$.address.$silentErrors
      }, null, 8 /* PROPS */, ["disabled", "modelValue", "is-dirty", "errors"])
    ])
  ]))
}